<template>
  <div :class="['modal', active && 'active']">
    <div @click="close" class="modal-close"></div>
    <div class="modal-container">
      <div v-if="title" class="modal-title">{{title}}</div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    title: String
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
@import "./style.scss";
</style>
